import httpService from '@/services/httpService'
import qs from 'qs'

const stripeHandler = {
  baseUrl: '/products/',
}

stripeHandler.handleError = err => {
  if (err.response && err.response.status && err.response.data) {
    const error = {
      code: err.response.data.code,
      message: err.response.data.message,
      additionalInformation: err.response.data.additionalInformation,
    }

    if (!error.message) {
      error.message =
        'Ett internt serverfel har skett. Vänligen försök igen eller kontakta support'
    }

    return error
  }
  return err
}

stripeHandler.startStripeSession = async args => {
  try {
    const request = {
      url: 'startStripeSession',
      data: qs.stringify(args),
      retry: false,
      requireLogin: true,
    }

    return await httpService.post(request)
  } catch (err) {
    throw stripeHandler.handleError(err)
  }
}

stripeHandler.startStripeSubscription = async args => {
  try {
    const request = {
      url: 'startStripeSub',
      data: qs.stringify(args),
      retary: false,
      requireLogin: true,
    }

    return await httpService.post(request)
  } catch (err) {
    throw stripeHandler.handleError(err)
  }
}

stripeHandler.getStripeStatus = async ({ paymentIntent, orderId }) => {
  try {
    const params = {
      paymentIntent: JSON.stringify(paymentIntent),
      orderId: JSON.stringify(orderId),
    }
    const url = `getStripeStatus`

    return await httpService.get({ url, params, timeout: 60000, retry: false })
  } catch (err) {
    throw stripeHandler.handleError(err)
  }
}

export default stripeHandler
